import { ALL_MCP_SCOPES, MCP_SCOPES } from "../../supabase/functions/_shared/mcp/registry";

export { ALL_MCP_SCOPES };
export {
  isAllowedRedirect,
  isAllowedRedirectTarget,
  redirectTargetOf,
} from "../../supabase/functions/_shared/mcp/redirects";

const CONSENT_RETURN = /^\/oauth\/consent(\?[A-Za-z0-9._~%&=+-]*)?$/;

export function consentReturnPath(next: string | null): string | null {
  return next && CONSENT_RETURN.test(next) ? next : null;
}

export interface ScopeCopy {
  label: string;
  description: string;
}

export const MCP_SCOPE_COPY: Record<string, ScopeCopy> = {
  [MCP_SCOPES.clientsRead]: {
    label: "Ver clientes",
    description: "Consultar las organizaciones cliente, su plan y el estado de su suscripción.",
  },
  [MCP_SCOPES.billingRead]: {
    label: "Ver facturación",
    description: "Consultar cobros, pagos y periodos de facturación.",
  },
  [MCP_SCOPES.clientsWrite]: {
    label: "Modificar clientes",
    description: "Crear o cambiar datos de las organizaciones cliente.",
  },
};

export const DEFAULT_GRANTED_SCOPES: string[] = [MCP_SCOPES.clientsRead];
